"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1348],{

/***/ 91348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ monday_integrations_connections_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/toggle.scss.js



var StyledToggle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eaeyf5k0"
})("display:flex;flex-direction:row;justify-content:center;background:var(--background-color);border-radius:30px;cursor:pointer;width:500px;font-size:0.875rem;.toggle-left{width:250px;background:var(--switch-color);padding:12px 20px;border-radius:30px;color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";text-align:center;}.toggle-right{width:250px;padding:12px 20px;border-radius:30px;color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";text-align:center;text-size:16px;}&.switch-texts-colors{.toggle-left{color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";}.toggle-right{color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}&.on{.toggle-left{background:unset;color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";}.toggle-right{background:var(--switch-color);color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}&.switch-texts-colors{.toggle-left{color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}.toggle-right{color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";}}}");

// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
;// CONCATENATED MODULE: ./components/core/toggle.js





var Toggle = function(props) {
    var handleToggle = props.handleToggle, toggleButtonColor = props.toggleButtonColor, toggleBackgroundColor = props.toggleBackgroundColor, leftPhrase = props.leftPhrase, rightPhrase = props.rightPhrase, swtichTextsColors = props.swtichTextsColors;
    var ref = (0,react.useState)(false), isOn = ref[0], setIsOn = ref[1];
    var toggleSwitch = function() {
        setIsOn(!isOn);
        handleToggle();
    };
    var onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(toggleSwitch);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledToggle, {
        className: classnames_default()("toggle", {
            on: isOn,
            "switch-texts-colors": swtichTextsColors
        }),
        onClick: toggleSwitch,
        style: {
            "--background-color": toggleBackgroundColor,
            "--switch-color": toggleButtonColor
        },
        role: "tablist",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "toggle-left",
                role: "tab",
                tabIndex: 0,
                onKeyDown: onKeyDown,
                "aria-label": leftPhrase,
                children: leftPhrase
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "toggle-right",
                role: "tab",
                tabIndex: 0,
                onKeyDown: onKeyDown,
                "aria-label": rightPhrase,
                children: rightPhrase
            })
        ]
    });
};
/* harmony default export */ var toggle = (Toggle);

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/monday-integrations-connections/default-props.js

/* harmony default export */ var default_props = ({
    theme: segments_service/* SPACE_BLUE_THEME_ID */.r8,
    componentTitle: "Your everyday tools. All in <b>one place.</b>",
    beforeAnimationSubTitle: "All your information and data—in one place.<br/> Expand the capabilities of work management with over 200 integrations and custom-built apps to<br/> save time and boost productivity, together. ",
    afterAnimationSubTitle: "All your information and data—in one place.<br/> Expand the capabilities of work management with over 200 integrations and custom-built apps to<br/> save time and boost productivity, together. ",
    switchRightPhrase: "With work management",
    switchLeftPhrase: "Without work management"
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
// EXTERNAL MODULE: ./constants/work-managment-logos.js
var work_managment_logos = __webpack_require__(74329);
;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/monday-integrations-connections/consts.js
var ICON_HEIGHT = 82;
var ICON_WIDTH = 75;
var LOGO_WRAPPER_HEIGHT = 340;
var LOGO_WRAPPER_WIDTH = 340;
var SVG_WIDTH = 1200;
var SVG_HEIGHT = 600;
var PATH_WIDTH = 25;
var CORNER_LENGTH = 15;
var LOGO_WIDTH = 200;
var AFTER_ANIMATION_RIGHT_ICON_X_LOCATION = 950;
var AFTER_ANIMATION_LEFT_ICON_X_LOCATION = 150;
var LONG_PATH_HORIZONTAL_LENGTH = 200;
var RIGHT_TO_LEFT = -1;
var LEFT_TO_RIGHT = 1;
var ICONS_ARRAY = [
    {
        iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-1.png",
        startLocation: [
            100,
            250
        ],
        endLocation: [
            AFTER_ANIMATION_LEFT_ICON_X_LOCATION,
            80
        ]
    },
    {
        iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-2.png",
        startLocation: [
            300,
            100
        ],
        endLocation: [
            AFTER_ANIMATION_LEFT_ICON_X_LOCATION,
            200
        ]
    },
    {
        iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-3.png",
        startLocation: [
            300,
            450
        ],
        endLocation: [
            AFTER_ANIMATION_LEFT_ICON_X_LOCATION,
            320
        ]
    },
    {
        iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-4.png",
        startLocation: [
            500,
            250
        ],
        endLocation: [
            AFTER_ANIMATION_LEFT_ICON_X_LOCATION,
            440
        ]
    },
    {
        iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-5.png",
        startLocation: [
            600,
            450
        ],
        endLocation: [
            AFTER_ANIMATION_RIGHT_ICON_X_LOCATION,
            80
        ]
    },
    {
        iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-6.png",
        startLocation: [
            700,
            100
        ],
        endLocation: [
            AFTER_ANIMATION_RIGHT_ICON_X_LOCATION,
            200
        ]
    },
    {
        iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-7.png",
        startLocation: [
            900,
            100
        ],
        endLocation: [
            AFTER_ANIMATION_RIGHT_ICON_X_LOCATION,
            320
        ]
    },
    {
        iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-8.png",
        startLocation: [
            900,
            450
        ],
        endLocation: [
            AFTER_ANIMATION_RIGHT_ICON_X_LOCATION,
            440
        ]
    }
];
var LOGO_DATA = {
    xLocation: (AFTER_ANIMATION_RIGHT_ICON_X_LOCATION + AFTER_ANIMATION_LEFT_ICON_X_LOCATION + ICON_WIDTH) / 2 - LOGO_WRAPPER_WIDTH / 2,
    yLocation: ICONS_ARRAY[0].endLocation[1] + (ICONS_ARRAY[3].endLocation[1] + ICON_HEIGHT - ICONS_ARRAY[0].endLocation[1]) / 2 - LOGO_WRAPPER_HEIGHT / 2
};
var LINES_DATA = [
    {
        startIcon: 1,
        endIcon: 2
    },
    {
        startIcon: 1,
        endIcon: 5
    },
    {
        startIcon: 2,
        endIcon: 4
    },
    {
        startIcon: 4,
        endIcon: 7
    },
    {
        startIcon: 6,
        endIcon: 7
    }
];
var ICONS_PATHS_DATA = [
    {
        origin: 0,
        destination: 3,
        length: LONG_PATH_HORIZONTAL_LENGTH
    },
    {
        origin: 4,
        destination: 7,
        length: -LONG_PATH_HORIZONTAL_LENGTH
    }
];
var LOGO_SIDE_PATHS_HEIGHT = ICONS_ARRAY[0].endLocation[1] + (ICONS_ARRAY[3].endLocation[1] + ICON_HEIGHT - ICONS_ARRAY[0].endLocation[1]) / 2;
var HORIZONTAL_PATHS_DATA = [
    {
        xStart: ICONS_ARRAY[0].endLocation[0] + ICON_WIDTH + PATH_WIDTH + LONG_PATH_HORIZONTAL_LENGTH,
        xEnd: LOGO_DATA.xLocation + PATH_WIDTH + (LOGO_WRAPPER_WIDTH - LOGO_WIDTH) / 2 + CORNER_LENGTH,
        yValue: LOGO_SIDE_PATHS_HEIGHT,
        direction: LEFT_TO_RIGHT
    },
    {
        xStart: LOGO_DATA.xLocation + LOGO_WRAPPER_WIDTH - (LOGO_WRAPPER_WIDTH - LOGO_WIDTH) / 2 - PATH_WIDTH - CORNER_LENGTH,
        xEnd: ICONS_ARRAY[5].endLocation[0] - LONG_PATH_HORIZONTAL_LENGTH - PATH_WIDTH,
        yValue: LOGO_SIDE_PATHS_HEIGHT,
        direction: RIGHT_TO_LEFT
    },
    {
        xStart: ICONS_ARRAY[0].endLocation[0] + ICON_WIDTH,
        xEnd: ICONS_ARRAY[0].endLocation[0] + ICON_WIDTH + LONG_PATH_HORIZONTAL_LENGTH + CORNER_LENGTH,
        yValue: ICONS_ARRAY[1].endLocation[1] + ICON_HEIGHT / 2,
        direction: LEFT_TO_RIGHT
    },
    {
        xStart: ICONS_ARRAY[0].endLocation[0] + ICON_WIDTH,
        xEnd: ICONS_ARRAY[0].endLocation[0] + ICON_WIDTH + LONG_PATH_HORIZONTAL_LENGTH + CORNER_LENGTH,
        yValue: ICONS_ARRAY[2].endLocation[1] + ICON_HEIGHT / 2,
        direction: LEFT_TO_RIGHT
    },
    {
        xStart: ICONS_ARRAY[5].endLocation[0] - LONG_PATH_HORIZONTAL_LENGTH - CORNER_LENGTH,
        xEnd: ICONS_ARRAY[5].endLocation[0],
        yValue: ICONS_ARRAY[5].endLocation[1] + ICON_HEIGHT / 2,
        direction: RIGHT_TO_LEFT
    },
    {
        xStart: ICONS_ARRAY[5].endLocation[0] - LONG_PATH_HORIZONTAL_LENGTH - CORNER_LENGTH,
        xEnd: ICONS_ARRAY[6].endLocation[0],
        yValue: ICONS_ARRAY[6].endLocation[1] + ICON_HEIGHT / 2,
        direction: RIGHT_TO_LEFT
    }
];

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/monday-integrations-connections/lines-svg-component.js





var LinesSvgComponent = function(props) {
    var theme = props.theme;
    var lineColor = (0,segments_service/* isDarkTheme */.$o)(theme) ? colors/* default */.Z[color_consts.WHITE_COLOR_NAME] : colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR];
    var renderLine = function(x1, x2, y1, y2) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
            "stroke-dasharray": "3",
            x1: x1,
            y1: x2,
            x2: y1,
            y2: y2,
            stroke: lineColor
        }, "".concat(x1, "_").concat(x2, "_").concat(y1, "_").concat(y2));
    };
    //draw lines between icons in the same axis
    var drawLineBetweenIcons = function(icon1index, icon2index) {
        if (ICONS_ARRAY[icon1index].startLocation[0] === ICONS_ARRAY[icon2index].startLocation[0]) {
            return renderLine(ICONS_ARRAY[icon1index].startLocation[0] + ICON_WIDTH / 2 + "px", ICONS_ARRAY[icon1index].startLocation[1] + ICON_HEIGHT + "px", ICONS_ARRAY[icon2index].startLocation[0] + ICON_WIDTH / 2 + "px", ICONS_ARRAY[icon2index].startLocation[1] + "px");
        } else if (ICONS_ARRAY[icon1index].startLocation[1] === ICONS_ARRAY[icon2index].startLocation[1]) {
            return renderLine(ICONS_ARRAY[icon1index].startLocation[0] + ICON_WIDTH + "px", ICONS_ARRAY[icon1index].startLocation[1] + ICON_HEIGHT / 2 + "px", ICONS_ARRAY[icon2index].startLocation[0] + "px", ICONS_ARRAY[icon2index].startLocation[1] + ICON_HEIGHT / 2 + "px");
        }
    };
    var drawHorizontalLine = function(startIconIndex, xEnd) {
        return renderLine(ICONS_ARRAY[startIconIndex].startLocation[0] + ICON_WIDTH + "px", ICONS_ARRAY[startIconIndex].startLocation[1] + ICON_HEIGHT / 2 + "px", ICONS_ARRAY[xEnd].startLocation[0] + ICON_WIDTH / 2 + "px", ICONS_ARRAY[startIconIndex].startLocation[1] + ICON_HEIGHT / 2 + "px");
    };
    var drawVerticalLine = function(startIconIndex, yEnd) {
        return renderLine(ICONS_ARRAY[startIconIndex].startLocation[0] + ICON_WIDTH / 2 + "px", ICONS_ARRAY[startIconIndex].startLocation[1] + ICON_HEIGHT + "px", ICONS_ARRAY[startIconIndex].startLocation[0] + ICON_WIDTH / 2 + "px", ICONS_ARRAY[yEnd].startLocation[1] + ICON_HEIGHT / 2 + "px");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: SVG_WIDTH,
        height: SVG_HEIGHT,
        className: "line",
        children: [
            LINES_DATA.map(function(line) {
                return drawLineBetweenIcons(line.startIcon, line.endIcon);
            }),
            drawHorizontalLine(0, 1),
            drawVerticalLine(3, 2)
        ]
    });
};
/* harmony default export */ var lines_svg_component = (LinesSvgComponent);

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/monday-integrations-connections/paths-and-circles-svg-component.js


var PathsAndCirclesSvgComponent = function(props) {
    var renderPath = function(pathData, pathKey) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: pathData,
            "stroke-opacity": "0.24",
            "stroke-width": "10",
            fill: "none",
            stroke: "white"
        }, pathKey);
    };
    var drawHorizontalPathBetweenPoints = function(xStart, xEnd, yValue) {
        var startPoint = "M" + xStart + "," + yValue;
        var endPoint = "" + xEnd + "," + yValue;
        var pathData = startPoint + " " + endPoint;
        return renderPath(pathData, "".concat(xStart, "_").concat(xEnd, "_").concat(yValue));
    };
    //draws a path between 2 icons in the same axis
    var drawPathBetweenIcons = function(icon1index, icon2index, horizontalDistance) {
        var topRightCorner = "a20,20 0 0 1 20,20";
        var bottomRightCorner = "a20,20 0 0 1 -20,20";
        var topLeftCorner = "a20,20 0 0 0 -20,20";
        var bottomLeftCorner = "a20,20 0 0 0 20,20";
        var startPointX = ICONS_ARRAY[icon1index].endLocation[0];
        if (horizontalDistance > 0) startPointX = startPointX + ICON_WIDTH;
        var startPointY = ICONS_ARRAY[icon1index].endLocation[1] + ICON_HEIGHT / 2;
        var startPointString = "M".concat(startPointX, ",").concat(startPointY);
        var verticalDistance = ICONS_ARRAY[icon2index].endLocation[1] - ICONS_ARRAY[icon1index].endLocation[1] - ICON_HEIGHT / 2;
        var pathData = horizontalDistance > 0 ? "".concat(startPointString, " h").concat(horizontalDistance, " ").concat(topRightCorner, " v").concat(verticalDistance, " ").concat(bottomRightCorner, " h-").concat(horizontalDistance) : "".concat(startPointString, " h-").concat(horizontalDistance * -1, " ").concat(topLeftCorner, " v").concat(verticalDistance, " ").concat(bottomLeftCorner, " h").concat(horizontalDistance * -1);
        return renderPath(pathData, startPointString);
    };
    var drawCirclesOnPath = function(icon1Index, icon2Index, distanceBetweenCircles, horizontalDistance) {
        var locations = [];
        var yAxisPathStartPoint = ICONS_ARRAY[icon1Index].endLocation[1] + ICON_HEIGHT / 2;
        var yAxisPathEndPoint = ICONS_ARRAY[icon2Index].endLocation[1] + ICON_HEIGHT / 2 - 1;
        var xAxisPathStartPoint = horizontalDistance > 0 ? ICONS_ARRAY[icon1Index].endLocation[0] + ICON_WIDTH + distanceBetweenCircles : -(ICONS_ARRAY[icon1Index].endLocation[0] - distanceBetweenCircles);
        var xAxisPathEndPoint = horizontalDistance > 0 ? xAxisPathStartPoint + horizontalDistance - (PATH_WIDTH + CORNER_LENGTH) : xAxisPathStartPoint - horizontalDistance - (PATH_WIDTH + CORNER_LENGTH);
        var sign = horizontalDistance > 0 ? 1 : -1;
        for(var i = xAxisPathStartPoint; i < xAxisPathEndPoint; i += distanceBetweenCircles){
            locations.push([
                sign * i,
                yAxisPathStartPoint
            ]);
        }
        ;
        for(var i1 = yAxisPathStartPoint + distanceBetweenCircles; i1 < yAxisPathEndPoint; i1 += distanceBetweenCircles){
            locations.push([
                sign * xAxisPathEndPoint,
                i1
            ]);
        }
        ;
        for(var i2 = xAxisPathStartPoint; i2 < xAxisPathEndPoint; i2 += distanceBetweenCircles){
            locations.push([
                sign * i2,
                yAxisPathEndPoint
            ]);
        }
        ;
        return locations.map(function(index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: index[0],
                cy: index[1],
                r: "3",
                "stroke-opacity": "0.75",
                fill: "white",
                stroke: "white"
            }, "".concat(index[0], "_").concat(index[1]));
        });
    };
    var drawHorizontalCirclesBetweenPoints = function(point1X, point2X, YValue, distanceBetweenCircles, direction) {
        var locations = [];
        var counter = 1;
        if (direction > 0) {
            for(var i = point1X + distanceBetweenCircles; i < point2X; i += distanceBetweenCircles){
                locations.push([
                    i,
                    counter
                ]);
            }
        } else {
            for(var i1 = point2X - distanceBetweenCircles; i1 > point1X; i1 -= distanceBetweenCircles){
                locations.push([
                    i1,
                    counter
                ]);
            }
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: locations.map(function(array) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: array[0],
                    cy: YValue,
                    r: "3",
                    "stroke-opacity": "0.75",
                    fill: "white",
                    stroke: "white"
                }, "".concat(array[0], "_").concat(YValue));
            })
        });
    };
    var renderPathsAndCircles = function() {
        return [
            ICONS_PATHS_DATA.map(function(path) {
                return drawPathBetweenIcons(path.origin, path.destination, path.length);
            }),
            ICONS_PATHS_DATA.map(function(path) {
                return drawCirclesOnPath(path.origin, path.destination, 60, path.length);
            }),
            HORIZONTAL_PATHS_DATA.map(function(path) {
                return drawHorizontalPathBetweenPoints(path.xStart, path.xEnd, path.yValue);
            }),
            HORIZONTAL_PATHS_DATA.map(function(path) {
                return drawHorizontalCirclesBetweenPoints(path.xStart, path.xEnd, path.yValue, 60, path.direction);
            })
        ];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: SVG_WIDTH,
        height: SVG_HEIGHT,
        className: "paths",
        children: renderPathsAndCircles()
    });
};
/* harmony default export */ var paths_and_circles_svg_component = (PathsAndCirclesSvgComponent);

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/monday-integrations-connections/monday-integrations-connections-component.scss.js


var StyledMondayIntegrationsConnectionsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ec927hm0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;flex-direction:column;align-items:center;overflow:hidden;.monday-integrations-wrapper{position:relative;display:flex;flex-direction:column;.title-wrapper{padding-bottom:50px;text-align:center;}.toggle-wrapper{display:flex;justify-content:center;}.before-animation-paragraph-wrapper{text-align:center;padding-top:30px;padding-botton:20px;}.after-animation-paragraph-wrapper{display:none;text-align:center;padding-top:30px;padding-botton:20px;}.icons-and-lines-wrapper{position:relative;.monday-logo{position:absolute;left:var(--left);top:var(--top);opacity:0;transition:opacity 1s;.picture-component{img{max-height:340px;}}}.icon{position:absolute;top:var(--y-before);left:var(--x-before);transition:top 1s,left 1s;}.line{transition:opacity 1s;}.paths{display:none;}}&.animation{.before-animation-paragraph-wrapper{display:none;}.after-animation-paragraph-wrapper{display:unset;}.icons-and-lines-wrapper{.monday-logo{opacity:1;}.icon{top:var(--y-after);left:var(--x-after);}.line{opacity:0;display:none;}.paths{display:unset;}}}}@media (min-width:", vp_sizes/* TABLET_QUERY_MIN_WIDTH */.Al, ") and (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.monday-integrations-wrapper{display:flex;.before-animation-paragraph-wrapper{padding:0 350px;}.after-animation-paragraph-wrapper{padding:0 350px;}.icons-and-lines-wrapper{transform:scale(0.75);}}}@media (min-width:", vp_sizes/* MOBILE_QUERY_MIN_WIDTH */.Lk, ") and (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.monday-integrations-wrapper{display:flex;.title-wrapper{padding-bottom:20px;.core-title-container .core-title{font-size:1.575rem;}}.toggle-wrapper{.toggle{width:350px;.toggle-left{width:175px;font-size:0.6875rem;padding:10px 10px;}.toggle-right{width:175px;font-size:0.6875rem;padding:10px 10px;}}}.before-animation-paragraph-wrapper{padding:20px 350px;.paragraph-wrapper .paragraph-body{font-size:0.875rem;line-height:30px;}}.after-animation-paragraph-wrapper{padding:20px 350px;.paragraph-wrapper .paragraph-body{font-size:0.875rem;line-height:30px;}}.icons-and-lines-wrapper{transform:scale(0.45) translatey(-50px);height:60vw;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){.monday-integrations-wrapper{display:flex;.title-wrapper{padding-bottom:20px;.core-title-container .core-title{font-size:1.125rem;}}.toggle-wrapper{.toggle{width:330px;.toggle-left{width:165px;font-size:0.6875rem;padding:8px 4px;}.toggle-right{width:165px;font-size:0.6875rem;padding:8px 4px;}}}.before-animation-paragraph-wrapper{padding:20px 450px;.paragraph-wrapper .paragraph-body{font-size:0.8125rem;line-height:20px;}}.after-animation-paragraph-wrapper{padding:20px 450px;.paragraph-wrapper .paragraph-body{font-size:0.8125rem;line-height:20px;}}.icons-and-lines-wrapper{transform:scale(0.35) translatey(-150px);height:60vw;}}}@media (max-width:", vp_sizes/* SMALL_MOBILE_QUERY_MAX_WIDTH */.cb, "){.monday-integrations-wrapper{display:flex;.title-wrapper{.core-title-container .core-title{font-size:0.875rem;}}.toggle-wrapper{.toggle{width:280px;.toggle-left{width:140px;font-size:0.563rem;padding:6px 4px;}.toggle-right{width:140px;font-size:0.563rem;padding:6px 4px;}}}.icons-and-lines-wrapper{transform:scale(0.3) translatey(-150px);}}}");

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/monday-integrations-connections/monday-integrations-connections-component.js
















var MondayIntegrationsConnectionsComponent = function(props) {
    var theme = props.theme, componentTitle = props.componentTitle, beforeAnimationSubTitle = props.beforeAnimationSubTitle, afterAnimationSubTitle = props.afterAnimationSubTitle, switchRightPhrase = props.switchRightPhrase, switchLeftPhrase = props.switchLeftPhrase;
    var ref = (0,react.useState)(false), animationIsOn = ref[0], setAnimationState = ref[1];
    var switchbackground = (0,segments_service/* isDarkTheme */.$o)(theme) ? colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME] : colors/* default */.Z[color_consts.LIGHT_WORK_OS_IRIS_COLOR_NAME];
    var switchTextsColors = !(0,segments_service/* isDarkTheme */.$o)(theme);
    var changeAnimationState = function() {
        setAnimationState(!animationIsOn);
    };
    var renderIcons = function() {
        return ICONS_ARRAY.map(function(icon) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "icon",
                style: {
                    "--x-before": "".concat(icon.startLocation[0], "px"),
                    "--y-before": "".concat(icon.startLocation[1], "px"),
                    "--x-after": "".concat(icon.endLocation[0], "px"),
                    "--y-after": "".concat(icon.endLocation[1], "px")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: icon.iconImage
                })
            }, "".concat(icon.startLocation[0], "_").concat(icon.startLocation[1], "_").concat(icon.endLocation[0], "_").concat(icon.endLocation[1], "}"));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMondayIntegrationsConnectionsComponent, {
        className: "monday-integrations-connections-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("monday-integrations-wrapper", {
                animation: animationIsOn
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "title-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                        title: componentTitle
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "toggle-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle, {
                        handleToggle: changeAnimationState,
                        leftPhrase: switchLeftPhrase,
                        rightPhrase: switchRightPhrase,
                        toggleBackgroundColor: switchbackground,
                        toggleButtonColor: colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME],
                        swtichTextsColors: switchTextsColors,
                        isOn: animationIsOn
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "icons-and-lines-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "monday-logo",
                            style: {
                                "--left": "".concat(LOGO_DATA.xLocation, "px"),
                                "--top": "".concat(LOGO_DATA.yLocation, "px")
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                src: work_managment_logos/* default.WM_INTEGRATION_LOGO */.Z.WM_INTEGRATION_LOGO
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            classNames: "SVGs-container",
                            children: [
                                renderIcons(),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lines_svg_component, {
                                    theme: theme
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(paths_and_circles_svg_component, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "before-animation-paragraph-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                        body: beforeAnimationSubTitle
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "after-animation-paragraph-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                        body: afterAnimationSubTitle
                    })
                })
            ]
        })
    });
};
MondayIntegrationsConnectionsComponent.defaultProps = default_props;
/* harmony default export */ var monday_integrations_connections_component = (MondayIntegrationsConnectionsComponent);


/***/ })

}]);